import styled from "@emotion/styled";
import { Box } from "@mui/material";

const CenteredBox = styled(Box)({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  px: 3,
});

export { CenteredBox };
